import { httpRequest } from "../../http";
import { FieldMapDocument } from "@models/fieldMap.model";
export class CommandSaveFieldMap {
  async run(definitionId: number, doc: FieldMapDocument): Promise<FieldMapDocument> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/field-map/`;
    return httpRequest<FieldMapDocument>(url, { method: "PUT", body: doc });
  }
}
